import { MealTime } from "@/clients/models/MealTime";

/**
 * Generate dynamic page title based on meal time
 */
export const getMealTimePageTitle = (mealTime?: MealTime): string => {
  switch (mealTime) {
    case MealTime.BREAKFAST:
      return "Swap your breakfast";
    case MealTime.LUNCH:
      return "Swap your lunch";
    case MealTime.DINNER:
      return "Swap your dinner";
    case MealTime.SNACK:
      return "Swap your snack";
    default:
      return "Swap your meal";
  }
};
